import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material'
import styled from 'styled-components'

export type StackPropsType = MuiStackProps

const Stack = styled(MuiStack)<StackPropsType>``

export default Stack
